import { ToastContainer, toast } from "react-toastify";
import Notificaciones from "./features/notificaciones/Notificaciones.jsx";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./features/layout/layout.jsx";
import BusquedaTurnos from "./features/BusquedaTurnos/BusquedaTurnos.jsx";
import { useState } from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import "./App.css";
import { Snackbar, Alert, Grow } from '@mui/material';
import ResumenTurnos from "./features/ResumenTurnos/ResumenTurnos.jsx"; 
import MedicoConfigPage from "./features/medicosConfig/MedicoConfigPage.jsx";

import MisTurnos from "./features/MisTurnos/MisTurnos.jsx";
import DashboardTurnos from "./components/DashboardTurnos";

import { AuthProvider } from './context/authContext.jsx';
import PrivateRoute from './components/privateRoute/privateRoute.jsx';
import LoginPage from './features/LoginPage/loginPage.jsx';
import RegistroPage from './features/registroPage/registroPage.jsx';

const theme = createTheme({
  palette: {
    primary: { main: '#D50032' },
    text: { primary: '#363636' }
  },
  typography: { fontFamily: "Arial, sans-serif" },
});

/* esto ya no me sirve
function GrowTransition(props) {
  return <Grow {...props} />;
}
*/

function App() {
  const [turnosPreseleccionados, setTurnosPreseleccionados] = useState([]);
  //  const [notificacion, setNotificacion] = useState({ abierta: false, mensaje: "", gravedad: "success" });

  const agregarTurno = (turno) => {
    if (!turnosPreseleccionados.find(t => t.id === turno.id)) {
      setTurnosPreseleccionados([...turnosPreseleccionados, turno]);
      toast.success(`Turno con ${turno.medico} preseleccionado.`);
    } else {
      toast.warning(`El turno con ${turno.medico} ya está en tu lista.`);
    }
  };

  const eliminarTurno = (idTurno) => {
    setTurnosPreseleccionados(turnosPreseleccionados.filter(t => t.id !== idTurno));
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        theme="colored"
      />
      <AuthProvider>
        <Routes>

          <Route path="/login" element={<LoginPage />} />
          <Route path="/registro" element={<RegistroPage />} />

          <Route path="/" element={<Layout carrito={turnosPreseleccionados} eliminarTurno={eliminarTurno} />}>

            <Route
              index
              element={
                <PrivateRoute rolesPermitidos={["PACIENTE"]}>
                  <BusquedaTurnos agregarTurno={agregarTurno} />
                </PrivateRoute>
              }
            />

            <Route path="/notificaciones" element={

              <PrivateRoute>
                <Notificaciones />
              </PrivateRoute>
            } />

            <Route path="/turnos" element={

              <PrivateRoute>
                <MisTurnos />
              </PrivateRoute>

            } />
            <Route
              path="/dashboard-turnos"
              element={
                <PrivateRoute rolesPermitidos={['MEDICO']}>
                  <DashboardTurnos />
                </PrivateRoute>
              }
            />
            <Route path="resumen" element={
              <PrivateRoute rolesPermitidos={['PACIENTE']}>
                <ResumenTurnos carrito={turnosPreseleccionados} eliminarTurno={eliminarTurno} />
              </PrivateRoute>
            } />

            <Route path="serviciosMedico" element={

              <PrivateRoute rolesPermitidos={['MEDICO']}>
                <MedicoConfigPage />
              </PrivateRoute>

            } />

          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;